// Shared import-user pieces duplicated (byte-identical) between
// UserManagement and UserChatManagement. Only the exact-duplicate parts live
// here: the CSV FileReader construction and the import confirmation dialog.
// validateData / ImportUser / the per-view warning helpers stay file-local
// (they genuinely diverge) and are reached via this.* template-method calls.
export default {
  methods: {
    // Builds the FileReader used for the CSV branch of processUpload; the
    // caller keeps the readAsText(...) call so the surrounding if/else-if
    // chain (Excel branch, invalid-file-type warning) stays per-view.
    createCsvImportReader() {
      const reader = new FileReader();
      reader.onload = (event) => {
        const text = event.target.result;
        const rows = text.split("\n").map((row) => row.split(","));
        const headers = rows[0].map((header) => header.trim());
        const jsonData = rows
          .slice(1)
          .map((row) => {
            const obj = {};
            row.forEach((cell, index) => {
              obj[headers[index]] = cell.trim();
            });
            return obj;
          })
          .filter((row) => Object.keys(row).length > 0);

        this.validateData(jsonData);
      };
      return reader;
    },
    ConfirmProcess() {
      this.$swal
        .fire({
          icon: "warning",
          title: this.$t("importUserTitle"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.ImportUser();
          }
        });
    },
  },
};
